import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Box } from "@mui/material";

import Button, { ButtonVariant, ButtonType } from "common/basicComponents/Button";
import {
  addNotification,
  NotificationVariant,
} from "components/notifications/NotificationSlice";
import { addCard, getSetup } from "../BillingActions";

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const { t } = useTranslation("billing");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;
    setSubmitting(true);

    const result = await stripe.confirmSetup({
      elements,
      redirect: "if_required",
    });

    if (result.error) {
      dispatch(
        addNotification({
          variant: NotificationVariant.ERROR,
          message: result.error.message,
        })
      );
      setSubmitting(false);
      return;
    }

    const ok = await addCard(result?.setupIntent?.payment_method);
    if (ok) {
      dispatch(
        addNotification({
          variant: NotificationVariant.SUCCESS,
          message: t("cardAdded"),
        })
      );
      await getSetup();
    }
    setSubmitting(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <Box style={{ marginTop: "16px" }}>
        <Button
          disabled={!stripe || !elements || submitting}
          isLoading={submitting}
          text={t("common:button.save")}
          variant={ButtonVariant.OUTLINED}
          type={ButtonType.SUBMIT}
        />
      </Box>
    </form>
  );
};

export default CheckoutForm;
